// leagues.js
import Axios from "../connection";
import { applicationError } from "../../../redux/actions/error";

export const afGetLeagues = async (country, season) => {
  try {
    const response = await Axios.get(
      `/leagues?${country === "World" ? `country=${country}` : `code=${country}`}&season=${season}`,
    );

    if (!response.data.response || response.data.response.length === 0) {
      return [];
    }

    return response.data.response.map((leagueData) => {
      const season = leagueData.seasons[0];
      const coverage = season.coverage;

      return {
        league_id: leagueData.league.id,
        name: leagueData.league.name,
        type: leagueData.league.type,
        logo: leagueData.league.logo,
        country: leagueData.country.name,
        country_code: leagueData.country.code,
        flag: leagueData.country.flag,
        season: season.year,
        season_start: season.start,
        season_end: season.end,
        standings: coverage.standings ? 1 : 0,
        is_current: season.current ? 1 : 0,
        coverage: {
          fixtures: {
            events: coverage.fixtures.events,
            lineups: coverage.fixtures.lineups,
          },
          standings: coverage.standings,
          players: coverage.players,
          topScorers: coverage.top_scorers,
          predictions: coverage.predictions,
          odds: coverage.odds,
          statistics: coverage.fixtures.statistics_fixtures,
          player_statistics: coverage.fixtures.statistics_players,
        },
      };
    });
  } catch (err) {
    applicationError({
      err,
      message: "Unable to fetch leagues",
      errorCode: "api-football",
    });
    throw err;
  }
};
